const routes = [{
  path: '/appointment',
  component: () => import('@/views/appointment'),
  name: 'appointment'
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/appointment.js